import angular from 'angular';
import keyboard from 'keycode-ui';
import PubSub from 'pubsub-js';
import _ from 'lodash';

const deps = {};
/*---------------------------------------------------------*\
 * EnlargedLivefeedController
\*---------------------------------------------------------*/
class EnlargedLivefeedController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($state, $rootScope, $element, $stateParams, navigationService, topics, states) {
    deps.topics = topics;
    deps.$state = $state;
    deps.$element = $element;
    deps.states = states;
    deps.$stateParams = $stateParams;
    deps.$rootScope = $rootScope;
    this.feedConfig = deps.$stateParams.currentStory;
    this.name = 'enlargedLivefeed';
    this.liveFeed = null;
    navigationService.focusEl('.navbar');
  }

  goBack() {
    deps.$state.go(deps.$rootScope.previousState.name, deps.$rootScope.previousParams);
  }
  onLiveFeedReady(liveFeed) {
    if (angular.isObject(liveFeed) && !_.isUndefined(liveFeed.API)) {
      this.liveFeed = liveFeed;
    }
  }

  remoteKeyup(e) {
    if (keyboard.isPlayPause(e) && this.liveFeed) {
      this.liveFeed.playPause();
    } else if (keyboard.isBack(e)) {
      e.preventDefault();
      e.stopPropagation();
      PubSub.publish(deps.topics.remoteKeys.back, { e });
      this.goBack();
    }
  }
}

EnlargedLivefeedController.$inject = [
  '$state',
  '$rootScope',
  '$element',
  '$stateParams',
  'navigationService',
  'topics',
  'states'
];

export default EnlargedLivefeedController;



/** WEBPACK FOOTER **
 ** ./client/app/components/enlargedLivefeed/enlargedLivefeed.controller.js
 **/